import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../auth'
import { useI18n } from '../i18n'
import { supabase } from '../lib/supabase'
import { avvFehlerText } from '../lib/avv'
import { avvHerunterladen, avvZeit } from '../lib/avvDownload'
import { avvAnnahmenLaden, type AvvNachweis } from '../data/supabaseAdapter'
import { Button } from '../ui/kit'
export default function AvvNachweise() {
  const { tenantId, session, rolle, mode } = useAuth()
  const { lang } = useI18n()
  const [rows, setRows] = useState<AvvNachweis[]>([])
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const scope = mode === 'live' && rolle === 'owner' ? `${session?.user.id}:${tenantId}` : ''
  const current = useRef(scope)
  current.current = scope
  const [loadedFor, setLoadedFor] = useState('')
  useEffect(() => {
    let active = true
    setRows([]); setLoadedFor(''); setError(null); setBusy(false)
    if (!scope || !supabase || !tenantId || !session) return
    void avvAnnahmenLaden(supabase, tenantId).then(r => {
      if (active && current.current === scope) { setRows(r); setLoadedFor(scope) }
    }).catch(() => { if (active) setError(lang === 'de' ? 'Nachweise konnten nicht geladen werden.' : 'Acceptance records could not be loaded.') })
    return () => { active = false; if (current.current === scope) current.current = '' }
  }, [scope])
  if (!scope) return null
  const download = async (n: AvvNachweis) => {
    if (!supabase || !tenantId || busy || loadedFor !== scope) return
    setBusy(true); setError(null)
    try { await avvHerunterladen(supabase, tenantId, n, () => current.current === scope) }
    catch (e) {
      if (current.current === scope) setError(avvFehlerText(e instanceof Error && e.message === 'avv_hash_abweichend' ? e.message : null, null, lang))
    } finally { if (current.current === scope) setBusy(false) }
  }
  return <section className="space-y-2 border-t border-border pt-3">
    <h3 className="font-medium">{lang === 'de' ? 'Auftragsverarbeitung (AVV)' : 'Data processing agreements'}</h3>
    {error && <p role="alert" className="text-sm text-danger">{error}</p>}
    {loadedFor === scope && rows.length === 0 && <p className="text-sm text-muted">{lang === 'de' ? 'Noch keine Annahme gespeichert.' : 'No acceptance recorded yet.'}</p>}
    {loadedFor === scope && rows.map(n => <div key={n.id} className="text-sm space-y-1 border border-border rounded-xl p-3">
      <p>{n.fassung_kennung}</p><p>{avvZeit(n.angenommen_at, lang === 'de')} · {n.angenommen_von_email}</p>
      <p className="font-mono break-all text-xs">{n.ausfertigung_sha256}</p>
      <Button type="button" size="sm" variant="ghost" onClick={() => void navigator.clipboard?.writeText(n.ausfertigung_sha256).catch(() => {})}>{lang === 'de' ? 'Prüfsumme kopieren' : 'Copy checksum'}</Button>
      <Button type="button" size="sm" disabled={busy} onClick={() => void download(n)}>{lang === 'de' ? 'Herunterladen' : 'Download'}</Button>
    </div>)}
  </section>
}
